
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 6.1.0
 * Query Engine version: 11f085a2012c0f4778414c8db2651556ee0ef959
 */
Prisma.prismaVersion = {
  client: "6.1.0",
  engine: "11f085a2012c0f4778414c8db2651556ee0ef959"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  isProjectClient: 'isProjectClient',
  isBuildStudioClient: 'isBuildStudioClient',
  pipefyClientCardId: 'pipefyClientCardId',
  accountId: 'accountId',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.RenderFeedbackScalarFieldEnum = {
  id: 'id',
  externalId: 'externalId',
  userId: 'userId',
  yzAnonymousId: 'yzAnonymousId',
  likedAt: 'likedAt',
  dislikedAt: 'dislikedAt',
  style: 'style',
  comments: 'comments',
  likedFrom: 'likedFrom',
  imageUrl: 'imageUrl',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.AccountScalarFieldEnum = {
  id: 'id',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.ApiKeyScalarFieldEnum = {
  digest: 'digest',
  id: 'id',
  expiresTs: 'expiresTs',
  roles: 'roles',
  createdTs: 'createdTs',
  revokedTs: 'revokedTs',
  userId: 'userId'
};

exports.Prisma.BuildRegionScalarFieldEnum = {
  id: 'id',
  internalName: 'internalName',
  displayName: 'displayName',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs',
  lastUpdatedBy: 'lastUpdatedBy',
  archived: 'archived',
  isDefault: 'isDefault',
  contractorId: 'contractorId',
  minLat: 'minLat',
  maxLat: 'maxLat',
  minLng: 'minLng',
  maxLng: 'maxLng',
  accountManagerId: 'accountManagerId'
};

exports.Prisma.AccountManagerScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  projectManagerId: 'projectManagerId',
  email: 'email',
  name: 'name',
  bio: 'bio',
  thumbnailMediaId: 'thumbnailMediaId',
  consultCallUrl: 'consultCallUrl',
  kickOffCallUrl: 'kickOffCallUrl',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs',
  isActive: 'isActive',
  eligibleForRandAssign: 'eligibleForRandAssign',
  isLastRoundRobinAssigned: 'isLastRoundRobinAssigned',
  slackChannelId: 'slackChannelId',
  zendeskEmail: 'zendeskEmail'
};

exports.Prisma.AccountManagerGroupScalarFieldEnum = {
  id: 'id',
  key: 'key',
  name: 'name',
  description: 'description',
  isActive: 'isActive',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.AccountManagerGroupMemberScalarFieldEnum = {
  accountManagerId: 'accountManagerId',
  groupId: 'groupId',
  isLastRoundRobinAssignedInGroup: 'isLastRoundRobinAssignedInGroup',
  createdTs: 'createdTs'
};

exports.Prisma.Spatial_ref_sysScalarFieldEnum = {
  srid: 'srid',
  auth_name: 'auth_name',
  auth_srid: 'auth_srid',
  srtext: 'srtext',
  proj4text: 'proj4text'
};

exports.Prisma.GalleryImageScalarFieldEnum = {
  id: 'id',
  airtableId: 'airtableId',
  city: 'city',
  state: 'state',
  region: 'region',
  styles: 'styles',
  designPackage: 'designPackage',
  amenities: 'amenities',
  fingerprint: 'fingerprint',
  yardAttributes: 'yardAttributes',
  ranking: 'ranking'
};

exports.Prisma.ConversationScalarFieldEnum = {
  id: 'id',
  sid: 'sid',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs',
  archived: 'archived',
  archivedTs: 'archivedTs'
};

exports.Prisma.ConversationParticipantScalarFieldEnum = {
  id: 'id',
  twilioId: 'twilioId',
  conversationId: 'conversationId',
  role: 'role',
  twilioSid: 'twilioSid',
  contractorId: 'contractorId',
  userProfileId: 'userProfileId',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.MessageScalarFieldEnum = {
  id: 'id',
  sid: 'sid',
  conversationId: 'conversationId',
  body: 'body',
  author: 'author',
  fromAccountManager: 'fromAccountManager',
  stalenessAnalyzed: 'stalenessAnalyzed',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.ConversationParticipantCursorScalarFieldEnum = {
  id: 'id',
  conversationParticipantId: 'conversationParticipantId',
  messageId: 'messageId',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.ScheduledSmsNotificationsScalarFieldEnum = {
  id: 'id',
  status: 'status',
  sid: 'sid',
  phone: 'phone',
  participantId: 'participantId',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.ScheduledNotificationScalarFieldEnum = {
  id: 'id',
  status: 'status',
  seen: 'seen',
  errors: 'errors',
  attempts: 'attempts',
  maxAttempts: 'maxAttempts',
  channel: 'channel',
  address: 'address',
  platform: 'platform',
  template: 'template',
  templateVariables: 'templateVariables',
  scheduledFor: 'scheduledFor',
  sentAt: 'sentAt',
  cancelledAt: 'cancelledAt',
  lastAttemptAt: 'lastAttemptAt',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.BuildProjectMemberScalarFieldEnum = {
  userId: 'userId',
  buildProjectId: 'buildProjectId'
};

exports.Prisma.BuildProjectScalarFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  accountManagerId: 'accountManagerId',
  internalNotes: 'internalNotes',
  proFacingNotes: 'proFacingNotes',
  firebaseProjectId: 'firebaseProjectId',
  pipefyClientCardId: 'pipefyClientCardId',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.EstimateScalarFieldEnum = {
  id: 'id',
  contractorId: 'contractorId',
  buildProjectId: 'buildProjectId',
  description: 'description',
  version: 'version',
  sentToClient: 'sentToClient',
  sentToClientTs: 'sentToClientTs',
  sentToClientBy: 'sentToClientBy',
  evaluationNotes: 'evaluationNotes',
  expectedStartDate: 'expectedStartDate',
  expectedEndDate: 'expectedEndDate',
  clonedFromEstimateId: 'clonedFromEstimateId',
  proEstimateNumber: 'proEstimateNumber',
  proTermDetails: 'proTermDetails',
  platformFee: 'platformFee',
  contractorDeposit: 'contractorDeposit',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.EstimateWorkLineItemScalarFieldEnum = {
  id: 'id',
  estimateId: 'estimateId',
  name: 'name',
  description: 'description',
  totalCost: 'totalCost',
  clientFeedbackNotes: 'clientFeedbackNotes',
  clientFeedbackTs: 'clientFeedbackTs',
  clonedFromEstimateWorkLineItemId: 'clonedFromEstimateWorkLineItemId',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.EstimatePaymentLineItemScalarFieldEnum = {
  id: 'id',
  estimateId: 'estimateId',
  name: 'name',
  paymentDue: 'paymentDue',
  totalAmountDue: 'totalAmountDue',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.EstimateBidFileScalarFieldEnum = {
  estimateId: 'estimateId',
  mediaId: 'mediaId',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.EvaluationTagScalarFieldEnum = {
  id: 'id',
  name: 'name',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.ItemTagScalarFieldEnum = {
  estimateLineItemId: 'estimateLineItemId',
  tagName: 'tagName',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.EstimateEvaluationTagScalarFieldEnum = {
  estimateId: 'estimateId',
  evaluationTagId: 'evaluationTagId',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.EstimateWorkItemTagDefScalarFieldEnum = {
  name: 'name',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.AddressScalarFieldEnum = {
  id: 'id',
  businessName: 'businessName',
  addressLine1: 'addressLine1',
  addressLine2: 'addressLine2',
  city: 'city',
  state: 'state',
  zipcode: 'zipcode',
  latitude: 'latitude',
  longitude: 'longitude',
  phone: 'phone',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.UserProfileScalarFieldEnum = {
  userId: 'userId',
  email: 'email',
  firstName: 'firstName',
  lastName: 'lastName',
  mailingAddressId: 'mailingAddressId',
  phone: 'phone',
  leadZipcode: 'leadZipcode',
  optIn: 'optIn',
  testAccount: 'testAccount',
  yzAnonymousId: 'yzAnonymousId',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.DesignAgentProfileScalarFieldEnum = {
  userId: 'userId',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  agentType: 'agentType',
  agentTier: 'agentTier',
  headshotId: 'headshotId',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.DesignAgentPermissionsScalarFieldEnum = {
  id: 'id',
  designAgentProfileId: 'designAgentProfileId',
  permissionType: 'permissionType',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.CustomerLeadsScalarFieldEnum = {
  yzAnonymousId: 'yzAnonymousId',
  userId: 'userId',
  email: 'email',
  firstName: 'firstName',
  lastName: 'lastName',
  leadSource: 'leadSource',
  zipcode: 'zipcode',
  addressLine1: 'addressLine1',
  addressLine2: 'addressLine2',
  city: 'city',
  state: 'state',
  score: 'score',
  leadScoreVersion: 'leadScoreVersion',
  phone: 'phone',
  homeEstimateValue: 'homeEstimateValue',
  leadRankScoreId: 'leadRankScoreId',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.CartScalarFieldEnum = {
  id: 'id',
  packageName: 'packageName',
  lotSize: 'lotSize',
  sku: 'sku',
  modifiedPrice: 'modifiedPrice',
  customerLeadId: 'customerLeadId',
  abandonedCartSlackSent: 'abandonedCartSlackSent',
  abandonedCartZendeskSent: 'abandonedCartZendeskSent',
  paymentIntentId: 'paymentIntentId',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.CartPromotionalCodeScalarFieldEnum = {
  id: 'id',
  code: 'code',
  discountType: 'discountType',
  discount: 'discount',
  cartId: 'cartId',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.CartAddOnScalarFieldEnum = {
  id: 'id',
  sku: 'sku',
  name: 'name',
  price: 'price',
  cartId: 'cartId',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.UserTermsOfServiceScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  tosAgreed: 'tosAgreed',
  typeOfTos: 'typeOfTos',
  dateOfAgree: 'dateOfAgree',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.ContractorAbilityScalarFieldEnum = {
  name: 'name'
};

exports.Prisma.ContractorAbilityLinkScalarFieldEnum = {
  name: 'name',
  contractorProfileId: 'contractorProfileId'
};

exports.Prisma.ProjectElementRequiredAbilityScalarFieldEnum = {
  name: 'name',
  projectElementId: 'projectElementId',
  contractorAbilityName: 'contractorAbilityName'
};

exports.Prisma.ProjectElementScalarFieldEnum = {
  id: 'id',
  name: 'name',
  category: 'category',
  notes: 'notes',
  budgetLowerBound: 'budgetLowerBound',
  budgetUpperBound: 'budgetUpperBound',
  rankingInCategory: 'rankingInCategory',
  seedId: 'seedId'
};

exports.Prisma.DesignProjectElementScalarFieldEnum = {
  id: 'id',
  name: 'name',
  hasuraBaseId: 'hasuraBaseId',
  hasuraBaseType: 'hasuraBaseType',
  hasuraBaseName: 'hasuraBaseName',
  unitName: 'unitName',
  unitCostAmtUsd: 'unitCostAmtUsd',
  laborCostAmtUsd: 'laborCostAmtUsd',
  projectElementId: 'projectElementId',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.BuildRegionsChangeLogScalarFieldEnum = {
  id: 'id',
  actionType: 'actionType',
  buildRegionId: 'buildRegionId',
  updatedTs: 'updatedTs',
  lastUpdatedBy: 'lastUpdatedBy'
};

exports.Prisma.MediaScalarFieldEnum = {
  id: 'id',
  bucketName: 'bucketName',
  objectName: 'objectName',
  mimeType: 'mimeType',
  uri: 'uri',
  order: 'order',
  uploadConfirmed: 'uploadConfirmed',
  uploaderId: 'uploaderId',
  contractorId: 'contractorId',
  buildProjectId: 'buildProjectId',
  estimateId: 'estimateId',
  designProjectId: 'designProjectId',
  messageId: 'messageId',
  source: 'source',
  tags: 'tags',
  revisionId: 'revisionId',
  designProjectDeliverableId: 'designProjectDeliverableId',
  createdTs: 'createdTs',
  notes: 'notes',
  designAgentProfileId: 'designAgentProfileId',
  feedbackMediaId: 'feedbackMediaId'
};

exports.Prisma.RevisionScalarFieldEnum = {
  id: 'id',
  contractorId: 'contractorId',
  shareMediaLink: 'shareMediaLink',
  clientFirstName: 'clientFirstName',
  clientLastName: 'clientLastName',
  projectCity: 'projectCity',
  projectState: 'projectState',
  projectPackage: 'projectPackage'
};

exports.Prisma.ContractorProfileScalarFieldEnum = {
  contractorId: 'contractorId',
  userId: 'userId',
  email: 'email',
  businessName: 'businessName',
  currentBuildRegionId: 'currentBuildRegionId',
  attributes: 'attributes',
  aboutSummary: 'aboutSummary',
  whyYardzenLovesSummary: 'whyYardzenLovesSummary',
  promotionalMessage: 'promotionalMessage',
  promotionalMessageStartDate: 'promotionalMessageStartDate',
  promotionalMessageEndDate: 'promotionalMessageEndDate',
  yearsInBusiness: 'yearsInBusiness',
  licenseNumber: 'licenseNumber',
  licenseExpirationDate: 'licenseExpirationDate',
  active: 'active',
  paused: 'paused',
  pausedTs: 'pausedTs',
  unpausedTs: 'unpausedTs',
  approved: 'approved',
  approvedTs: 'approvedTs',
  unapprovedTs: 'unapprovedTs',
  isTest: 'isTest',
  minSuccessBudget: 'minSuccessBudget',
  maxSuccessBudget: 'maxSuccessBudget',
  stripeConnectedAccountId: 'stripeConnectedAccountId',
  rating: 'rating',
  phoneNumber: 'phoneNumber',
  yelpUrl: 'yelpUrl',
  googleUrl: 'googleUrl',
  calendlyEmail: 'calendlyEmail',
  budgetRangeLowerBound: 'budgetRangeLowerBound',
  budgetRangeUpperBound: 'budgetRangeUpperBound',
  projectDigestFrequency: 'projectDigestFrequency',
  projectDigestLastSentTs: 'projectDigestLastSentTs',
  addressId: 'addressId',
  pausedStatusReason: 'pausedStatusReason',
  notApprovedStatusReason: 'notApprovedStatusReason',
  acceptingWork: 'acceptingWork',
  website: 'website',
  pipefyContractorCardId: 'pipefyContractorCardId',
  preferred: 'preferred',
  notes: 'notes',
  initialBuildRegionId: 'initialBuildRegionId',
  createdBy: 'createdBy',
  updatedBy: 'updatedBy',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.ContractorInsuranceScalarFieldEnum = {
  id: 'id',
  contractorId: 'contractorId',
  mediaId: 'mediaId',
  policyNumber: 'policyNumber',
  expirationDate: 'expirationDate',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.ContractorLicenseScalarFieldEnum = {
  id: 'id',
  contractorId: 'contractorId',
  mediaId: 'mediaId',
  licenseNumber: 'licenseNumber',
  expirationDate: 'expirationDate',
  confirmationLink: 'confirmationLink',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.ContractorContactScalarFieldEnum = {
  id: 'id',
  contractorId: 'contractorId',
  isPrimary: 'isPrimary',
  firstName: 'firstName',
  lastName: 'lastName',
  phone: 'phone',
  email: 'email',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.LoginHistoryScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  contractorId: 'contractorId',
  userAgent: 'userAgent',
  ipAddress: 'ipAddress',
  location: 'location',
  createdTs: 'createdTs'
};

exports.Prisma.ContractorReviewScalarFieldEnum = {
  id: 'id',
  contractorId: 'contractorId',
  author: 'author',
  summary: 'summary',
  reviewedTs: 'reviewedTs',
  source: 'source',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.BuildProjectElementScalarFieldEnum = {
  buildProjectId: 'buildProjectId',
  projectElementId: 'projectElementId',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.StyleProfileScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  yardLocation: 'yardLocation',
  maxBudget: 'maxBudget',
  timeline: 'timeline',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.SiteWalkScalarFieldEnum = {
  id: 'id',
  gcalEventId: 'gcalEventId',
  scheduledForDateStart: 'scheduledForDateStart',
  scheduledForDateEnd: 'scheduledForDateEnd',
  status: 'status',
  groupKey: 'groupKey',
  createdBy: 'createdBy',
  updatedBy: 'updatedBy',
  siteWalkSource: 'siteWalkSource',
  contractorId: 'contractorId',
  buildProjectId: 'buildProjectId',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.ContractorProjectLinkScalarFieldEnum = {
  contractorId: 'contractorId',
  buildProjectId: 'buildProjectId',
  pipefyDtbCardId: 'pipefyDtbCardId',
  totalContractValue: 'totalContractValue',
  pipefyCardPhaseId: 'pipefyCardPhaseId',
  matchSource: 'matchSource',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.ProjectContractorMatchScalarFieldEnum = {
  contractorId: 'contractorId',
  buildProjectId: 'buildProjectId',
  rank: 'rank',
  matchService: 'matchService',
  metadata: 'metadata',
  createdTs: 'createdTs',
  matchedTs: 'matchedTs'
};

exports.Prisma.ProjectEligibleContractorGraveyardScalarFieldEnum = {
  id: 'id',
  contractorId: 'contractorId',
  buildProjectId: 'buildProjectId',
  createdTs: 'createdTs',
  matchedTs: 'matchedTs',
  deathTs: 'deathTs',
  cadaver: 'cadaver'
};

exports.Prisma.MatchingRunLogScalarFieldEnum = {
  id: 'id',
  args: 'args',
  contractorIds: 'contractorIds',
  isLegacy: 'isLegacy',
  buildProjectId: 'buildProjectId',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.CityProjectElementScalarFieldEnum = {
  id: 'id',
  city: 'city',
  fingerprint: 'fingerprint',
  projectElementId: 'projectElementId',
  popularity: 'popularity',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.StyleProfileLikeGalleryImageScalarFieldEnum = {
  styleProfileId: 'styleProfileId',
  galleryImageId: 'galleryImageId'
};

exports.Prisma.ContractorMetricScalarFieldEnum = {
  marketId: 'marketId',
  contractorId: 'contractorId',
  contractorBusinessName: 'contractorBusinessName',
  introductionMade18MoQty: 'introductionMade18MoQty',
  marketIntroduction18MoCloseRate: 'marketIntroduction18MoCloseRate',
  engaged18MoQty: 'engaged18MoQty',
  marketEngaged18MoCloseRate: 'marketEngaged18MoCloseRate',
  contractSigned18MoQty: 'contractSigned18MoQty',
  avgContractAmount18MoUsd: 'avgContractAmount18MoUsd',
  introductionMade6MoQty: 'introductionMade6MoQty',
  marketIntroduction6MoCloseRate: 'marketIntroduction6MoCloseRate',
  engaged6MoQty: 'engaged6MoQty',
  marketEngaged6MoCloseRate: 'marketEngaged6MoCloseRate',
  contractSigned6MoQty: 'contractSigned6MoQty',
  avgContractAmount6MoUsd: 'avgContractAmount6MoUsd',
  introduction14DayQty: 'introduction14DayQty'
};

exports.Prisma.ContractorMetricAggregateScalarFieldEnum = {
  contractorId: 'contractorId',
  contractor6moMessageRate: 'contractor6moMessageRate',
  contractor6moCloseRate: 'contractor6moCloseRate',
  extractTs: 'extractTs'
};

exports.Prisma.MarketMetricScalarFieldEnum = {
  marketId: 'marketId',
  marketInternalName: 'marketInternalName',
  marketDisplayName: 'marketDisplayName',
  marketTier: 'marketTier',
  marketZipCodeArray: 'marketZipCodeArray',
  project18MoQty: 'project18MoQty',
  introductionMade18MoQty: 'introductionMade18MoQty',
  marketIntroduction18MoCloseRate: 'marketIntroduction18MoCloseRate',
  engaged18MoQty: 'engaged18MoQty',
  marketEngaged18MoCloseRate: 'marketEngaged18MoCloseRate',
  contractSigned18MoQty: 'contractSigned18MoQty',
  avgContractAmount18MoUsd: 'avgContractAmount18MoUsd',
  project6MoQty: 'project6MoQty',
  introductionMade6MoQty: 'introductionMade6MoQty',
  marketIntroduction6MoCloseRate: 'marketIntroduction6MoCloseRate',
  engaged6MoQty: 'engaged6MoQty',
  marketEngaged6MoCloseRate: 'marketEngaged6MoCloseRate',
  contractSigned6MoQty: 'contractSigned6MoQty',
  avgContractAmount6MoUsd: 'avgContractAmount6MoUsd'
};

exports.Prisma.StripePaymentIntentScalarFieldEnum = {
  id: 'id',
  object: 'object',
  amount: 'amount',
  amountCapturable: 'amountCapturable',
  amountReceived: 'amountReceived',
  application: 'application',
  applicationFeeAmount: 'applicationFeeAmount',
  canceledAt: 'canceledAt',
  cancellationReason: 'cancellationReason',
  captureMethod: 'captureMethod',
  clientSecret: 'clientSecret',
  confirmationMethod: 'confirmationMethod',
  created: 'created',
  currency: 'currency',
  customer: 'customer',
  description: 'description',
  stripeInvoice: 'stripeInvoice',
  lastPaymentError: 'lastPaymentError',
  latestCharge: 'latestCharge',
  livemode: 'livemode',
  nextAction: 'nextAction',
  onBehalfOf: 'onBehalfOf',
  paymentMethodId: 'paymentMethodId',
  paymentMethodTypes: 'paymentMethodTypes',
  processing: 'processing',
  receiptEmail: 'receiptEmail',
  review: 'review',
  setupFutureUsage: 'setupFutureUsage',
  shipping: 'shipping',
  source: 'source',
  statementDescriptor: 'statementDescriptor',
  statementDescriptorSuffix: 'statementDescriptorSuffix',
  status: 'status',
  transferData: 'transferData',
  transferGroup: 'transferGroup',
  amountDetails: 'amountDetails',
  automaticPaymentMethods: 'automaticPaymentMethods',
  metadata: 'metadata',
  paymentMethodOptions: 'paymentMethodOptions',
  invoiceId: 'invoiceId',
  paymentOrderId: 'paymentOrderId'
};

exports.Prisma.StripePaymentMethodScalarFieldEnum = {
  id: 'id',
  object: 'object',
  billingDetailsEmail: 'billingDetailsEmail',
  billingDetailsName: 'billingDetailsName',
  billingDetailsPhone: 'billingDetailsPhone',
  billingDetailsAddressCity: 'billingDetailsAddressCity',
  billingDetailsAddressCountry: 'billingDetailsAddressCountry',
  billingDetailsAddressLine1: 'billingDetailsAddressLine1',
  billingDetailsAddressLine2: 'billingDetailsAddressLine2',
  billingDetailsAddressPostalCode: 'billingDetailsAddressPostalCode',
  billingDetailsAddressState: 'billingDetailsAddressState',
  cardBrand: 'cardBrand',
  cardChecksAddressLine1Check: 'cardChecksAddressLine1Check',
  cardChecksAddressPostalCodeCheck: 'cardChecksAddressPostalCodeCheck',
  cardCvcCheck: 'cardCvcCheck',
  cardCountry: 'cardCountry',
  cardExpMonth: 'cardExpMonth',
  cardExpYear: 'cardExpYear',
  cardFingerprint: 'cardFingerprint',
  cardFunding: 'cardFunding',
  cardGeneratedFrom: 'cardGeneratedFrom',
  shipping: 'shipping',
  cardLast4: 'cardLast4',
  cardNetworksAvailable: 'cardNetworksAvailable',
  cardNetworksPreferred: 'cardNetworksPreferred',
  cardThreeDSecureUsageSupported: 'cardThreeDSecureUsageSupported',
  cardWallet: 'cardWallet',
  created: 'created',
  customer: 'customer',
  livemode: 'livemode',
  metadata: 'metadata',
  type: 'type'
};

exports.Prisma.StripeChargeScalarFieldEnum = {
  id: 'id',
  object: 'object',
  amount: 'amount',
  amountCaptured: 'amountCaptured',
  amountRefunded: 'amountRefunded',
  application: 'application',
  applicationFee: 'applicationFee',
  applicationFeeAmount: 'applicationFeeAmount',
  balanceTransaction: 'balanceTransaction',
  calculatedStatementDescriptor: 'calculatedStatementDescriptor',
  captured: 'captured',
  created: 'created',
  currency: 'currency',
  customer: 'customer',
  description: 'description',
  disputed: 'disputed',
  failureBalanceTransaction: 'failureBalanceTransaction',
  failureCode: 'failureCode',
  failureMessage: 'failureMessage',
  billingDetails: 'billingDetails',
  fraudDetails: 'fraudDetails',
  metadata: 'metadata',
  outcome: 'outcome',
  paymentMethodDetails: 'paymentMethodDetails',
  invoice: 'invoice',
  livemode: 'livemode',
  onBehalfOf: 'onBehalfOf',
  paid: 'paid',
  paymentIntent: 'paymentIntent',
  paymentMethod: 'paymentMethod',
  receiptEmail: 'receiptEmail',
  receiptNumber: 'receiptNumber',
  receiptUrl: 'receiptUrl',
  refunded: 'refunded',
  review: 'review',
  sourceTransfer: 'sourceTransfer',
  statementDescriptor: 'statementDescriptor',
  statementDescriptorSuffix: 'statementDescriptorSuffix',
  status: 'status',
  transferData: 'transferData',
  transferGroup: 'transferGroup'
};

exports.Prisma.StripeRefundScalarFieldEnum = {
  id: 'id',
  object: 'object',
  amount: 'amount',
  balanceTransaction: 'balanceTransaction',
  charge: 'charge',
  created: 'created',
  currency: 'currency',
  destinationDetails: 'destinationDetails',
  metadata: 'metadata',
  paymentIntent: 'paymentIntent',
  reason: 'reason',
  receiptNumber: 'receiptNumber',
  sourceTransferReversal: 'sourceTransferReversal',
  status: 'status',
  transferReversal: 'transferReversal'
};

exports.Prisma.StripeBalanceTransactionScalarFieldEnum = {
  id: 'id',
  amount: 'amount',
  currency: 'currency',
  feeDetails: 'feeDetails',
  fee: 'fee',
  description: 'description',
  status: 'status',
  source: 'source',
  created: 'created',
  type: 'type',
  exchangeRate: 'exchangeRate',
  net: 'net',
  availableOn: 'availableOn',
  reportingCategory: 'reportingCategory',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.StripeTaxTransactionScalarFieldEnum = {
  id: 'id',
  taxCalculationId: 'taxCalculationId',
  paymentIntentId: 'paymentIntentId',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.ElementContractorAbilityLinkScalarFieldEnum = {
  elementId: 'elementId',
  name: 'name',
  type: 'type',
  contractorAbilityName: 'contractorAbilityName'
};

exports.Prisma.InvoiceScalarFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  totalAmount: 'totalAmount',
  applicationFeeAmount: 'applicationFeeAmount',
  connectedAccountId: 'connectedAccountId',
  receiptEmail: 'receiptEmail',
  name: 'name',
  paymentMilestone: 'paymentMilestone',
  description: 'description',
  clientNotes: 'clientNotes',
  confirmationMessage: 'confirmationMessage',
  internalNotes: 'internalNotes',
  paid: 'paid',
  paymentDueTs: 'paymentDueTs',
  lastPaymentAttemptedTs: 'lastPaymentAttemptedTs',
  createdTs: 'createdTs',
  createdBy: 'createdBy',
  updatedTs: 'updatedTs',
  updatedBy: 'updatedBy',
  voidedTs: 'voidedTs',
  voidedBy: 'voidedBy',
  invoiceType: 'invoiceType',
  incrementalInvoiceNumber: 'incrementalInvoiceNumber',
  estimateInvoiceNumber: 'estimateInvoiceNumber',
  contractorId: 'contractorId',
  estimateId: 'estimateId',
  yzFeeRate: 'yzFeeRate',
  proInvoiceReference: 'proInvoiceReference'
};

exports.Prisma.InvoiceLineItemScalarFieldEnum = {
  id: 'id',
  invoiceId: 'invoiceId',
  name: 'name',
  description: 'description',
  unitAmount: 'unitAmount',
  quantity: 'quantity',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.InvoicePaybackTransferScalarFieldEnum = {
  invoiceId: 'invoiceId',
  stripeChargeId: 'stripeChargeId',
  stripeTransferId: 'stripeTransferId',
  stripePaymentId: 'stripePaymentId',
  amount: 'amount',
  paid: 'paid',
  createdTs: 'createdTs'
};

exports.Prisma.UrlScalarFieldEnum = {
  shortUrl: 'shortUrl',
  longUrl: 'longUrl',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.MutexScalarFieldEnum = {
  id: 'id',
  expiresTs: 'expiresTs',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.ActionAcknoledgmenetScalarFieldEnum = {
  key: 'key',
  acknowledgedTs: 'acknowledgedTs'
};

exports.Prisma.PipefyCardScalarFieldEnum = {
  cardId: 'cardId',
  pipe_id: 'pipe_id',
  phaseId: 'phaseId',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.PipefyActionScalarFieldEnum = {
  id: 'id',
  actiontype: 'actiontype',
  moveToStageId: 'moveToStageId',
  moveToStageName: 'moveToStageName',
  fieldUpdateId: 'fieldUpdateId',
  fieldUpdateName: 'fieldUpdateName',
  fieldUpdateInternalId: 'fieldUpdateInternalId',
  moveFromStageId: 'moveFromStageId',
  moveFromStageName: 'moveFromStageName',
  onPhaseId: 'onPhaseId',
  onPhaseName: 'onPhaseName',
  cardId: 'cardId',
  pipe_id: 'pipe_id',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.SurveyScalarFieldEnum = {
  id: 'id',
  surveyKey: 'surveyKey',
  surveyDesc: 'surveyDesc',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs',
  version: 'version',
  active: 'active',
  public: 'public'
};

exports.Prisma.SurveyQuestionScalarFieldEnum = {
  id: 'id',
  text: 'text',
  description: 'description',
  questionKey: 'questionKey',
  section: 'section',
  index: 'index',
  format: 'format',
  required: 'required',
  surveyId: 'surveyId',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.SurveyResponseScalarFieldEnum = {
  id: 'id',
  surveyId: 'surveyId',
  buildProjectId: 'buildProjectId',
  userId: 'userId',
  completed: 'completed',
  nextQuestionId: 'nextQuestionId',
  yzAnonymousId: 'yzAnonymousId',
  outcome: 'outcome',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.SurveyQuestionResponseScalarFieldEnum = {
  response: 'response',
  surveyResponseId: 'surveyResponseId',
  surveyQuestionId: 'surveyQuestionId',
  nextQuestionAskedId: 'nextQuestionAskedId',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.SurveyQuestionBranchScalarFieldEnum = {
  id: 'id',
  condition: 'condition',
  fromQuestionId: 'fromQuestionId',
  toQuestionId: 'toQuestionId',
  responseFromQuestionId: 'responseFromQuestionId'
};

exports.Prisma.InProgressPaymentScalarFieldEnum = {
  id: 'id',
  paymentIntentId: 'paymentIntentId',
  clientSecret: 'clientSecret',
  status: 'status',
  invoiceId: 'invoiceId',
  connectedAccountId: 'connectedAccountId',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.DesignInspirationLinkScalarFieldEnum = {
  id: 'id',
  buildProjectId: 'buildProjectId',
  link: 'link',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.DeprecatedProMatchScalarFieldEnum = {
  id: 'id',
  contractorId: 'contractorId',
  matchRank: 'matchRank',
  pipefyCardId: 'pipefyCardId',
  matchService: 'matchService',
  metadata: 'metadata',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs',
  archived: 'archived',
  archivedTs: 'archivedTs',
  totalContractValue: 'totalContractValue',
  buildProjectId: 'buildProjectId'
};

exports.Prisma.IdempotencyKeyScalarFieldEnum = {
  key: 'key',
  createdTs: 'createdTs'
};

exports.Prisma.ContractorShareLinkScalarFieldEnum = {
  id: 'id',
  revisionId: 'revisionId',
  userId: 'userId',
  contractorId: 'contractorId',
  createdForContractorId: 'createdForContractorId',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.EmailReplyStatusScalarFieldEnum = {
  id: 'id',
  sengridEmailId: 'sengridEmailId',
  from: 'from',
  conversationId: 'conversationId',
  status: 'status',
  lastProcessedTs: 'lastProcessedTs',
  error: 'error',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.ConfigScalarFieldEnum = {
  id: 'id',
  key: 'key',
  value: 'value',
  createdTs: 'createdTs'
};

exports.Prisma.PipefyPhaseMetadataScalarFieldEnum = {
  pipeId: 'pipeId',
  phaseId: 'phaseId',
  pipeName: 'pipeName',
  done: 'done',
  phaseName: 'phaseName',
  fields: 'fields',
  fieldConditions: 'fieldConditions'
};

exports.Prisma.PipefyFormSubmissionHistoryScalarFieldEnum = {
  id: 'id',
  pipefyCardId: 'pipefyCardId',
  contractorId: 'contractorId',
  updatedTs: 'updatedTs',
  createdTs: 'createdTs',
  phaseName: 'phaseName',
  phaseId: 'phaseId',
  questionsAndResponses: 'questionsAndResponses'
};

exports.Prisma.ZipCodeAnalysisScalarFieldEnum = {
  zipcode: 'zipcode',
  state: 'state',
  city: 'city',
  averagePropertyValue: 'averagePropertyValue',
  sampleDate: 'sampleDate',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.DesignProjectScalarFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs',
  accountManagerId: 'accountManagerId',
  designerProfileId: 'designerProfileId',
  houseModelerProfileId: 'houseModelerProfileId',
  stage: 'stage',
  currentDesignRevisionVersion: 'currentDesignRevisionVersion',
  packageType: 'packageType'
};

exports.Prisma.DesignProjectDeliverableScalarFieldEnum = {
  id: 'id',
  designProjectId: 'designProjectId',
  version: 'version',
  deliverableType: 'deliverableType',
  createdBy: 'createdBy',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.DesignProjectDeliverableFeedbackScalarFieldEnum = {
  id: 'id',
  designProjectDeliverableId: 'designProjectDeliverableId',
  notes: 'notes',
  feedbackType: 'feedbackType',
  authorId: 'authorId',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs',
  imageCoordinates: 'imageCoordinates',
  annotatedImageId: 'annotatedImageId'
};

exports.Prisma.DesignProjectDeliverableAssetScalarFieldEnum = {
  id: 'id',
  assetId: 'assetId',
  quantity: 'quantity',
  designProjectDeliverableId: 'designProjectDeliverableId',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs',
  createdBy: 'createdBy'
};

exports.Prisma.DesignProjectOnboardingStepScalarFieldEnum = {
  id: 'id',
  stepType: 'stepType',
  designProjectId: 'designProjectId',
  position: 'position',
  stage: 'stage',
  percentComplete: 'percentComplete',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.DesignProjectOnboardingBudgetScalarFieldEnum = {
  id: 'id',
  designProjectId: 'designProjectId',
  budgetPreference: 'budgetPreference',
  wishlistEstimateLow: 'wishlistEstimateLow',
  wishlistEstimateHigh: 'wishlistEstimateHigh',
  baseInstallationCostsLow: 'baseInstallationCostsLow',
  baseInstallationCostsHigh: 'baseInstallationCostsHigh',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.DesignProjectOnboardingStepProjectElementScalarFieldEnum = {
  designProjectOnboardingStepId: 'designProjectOnboardingStepId',
  projectElementId: 'projectElementId',
  selectedPriceLow: 'selectedPriceLow',
  selectedPriceHigh: 'selectedPriceHigh',
  installLocation: 'installLocation',
  notes: 'notes',
  priority: 'priority',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.BudgetDetailScalarFieldEnum = {
  id: 'id',
  wishlistEstimateLow: 'wishlistEstimateLow',
  wishlistEstimateHigh: 'wishlistEstimateHigh',
  baseInstallationCostsLow: 'baseInstallationCostsLow',
  baseInstallationCostsHigh: 'baseInstallationCostsHigh',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs',
  designProjectOnboardingStepId: 'designProjectOnboardingStepId'
};

exports.Prisma.PaymentOrderScalarFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  amount: 'amount',
  discountAmount: 'discountAmount',
  promoCode: 'promoCode',
  taxAmount: 'taxAmount',
  total: 'total',
  currency: 'currency',
  paymentOrderStatus: 'paymentOrderStatus',
  stripeChargeId: 'stripeChargeId',
  createdTs: 'createdTs'
};

exports.Prisma.PaymentOrderItemScalarFieldEnum = {
  paymentOrderId: 'paymentOrderId',
  productSku: 'productSku',
  quantity: 'quantity',
  unitPrice: 'unitPrice',
  discountAmount: 'discountAmount',
  taxAmount: 'taxAmount',
  totalPrice: 'totalPrice',
  createdTs: 'createdTs',
  designProjectId: 'designProjectId'
};

exports.Prisma.ProductScalarFieldEnum = {
  sku: 'sku',
  name: 'name',
  productType: 'productType',
  packageType: 'packageType',
  addOnType: 'addOnType',
  lotSize: 'lotSize',
  price: 'price',
  updatedTs: 'updatedTs',
  createdTs: 'createdTs'
};

exports.Prisma.LeadRankConfigScalarFieldEnum = {
  id: 'id',
  leadRankThreshold: 'leadRankThreshold',
  version: 'version',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.LeadRankScoreScalarFieldEnum = {
  id: 'id',
  leadRankScore: 'leadRankScore',
  leadRank: 'leadRank',
  homeValueSource: 'homeValueSource',
  leadRankConfigId: 'leadRankConfigId',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs'
};

exports.Prisma.VLatestConversationMessageScalarFieldEnum = {
  conversationId: 'conversationId',
  latestMessageCreatedTs: 'latestMessageCreatedTs'
};

exports.Prisma.VInvoiceScalarFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  totalAmount: 'totalAmount',
  applicationFeeAmount: 'applicationFeeAmount',
  connectedAccountId: 'connectedAccountId',
  receiptEmail: 'receiptEmail',
  name: 'name',
  paymentMilestone: 'paymentMilestone',
  description: 'description',
  clientNotes: 'clientNotes',
  confirmationMessage: 'confirmationMessage',
  internalNotes: 'internalNotes',
  paid: 'paid',
  paymentDueTs: 'paymentDueTs',
  lastPaymentAttemptedTs: 'lastPaymentAttemptedTs',
  createdTs: 'createdTs',
  createdBy: 'createdBy',
  updatedTs: 'updatedTs',
  updatedBy: 'updatedBy',
  voidedTs: 'voidedTs',
  voidedBy: 'voidedBy',
  invoiceType: 'invoiceType',
  incrementalInvoiceNumber: 'incrementalInvoiceNumber',
  estimateInvoiceNumber: 'estimateInvoiceNumber',
  contractorId: 'contractorId',
  estimateId: 'estimateId',
  yzFeeRate: 'yzFeeRate',
  proInvoiceReference: 'proInvoiceReference',
  stripeChargeId: 'stripeChargeId',
  stripeChargeObject: 'stripeChargeObject',
  stripeChargeAmount: 'stripeChargeAmount',
  stripeChargeAmountCaptured: 'stripeChargeAmountCaptured',
  stripeChargeAmountRefunded: 'stripeChargeAmountRefunded',
  stripeChargeApplication: 'stripeChargeApplication',
  stripeChargeApplicationFee: 'stripeChargeApplicationFee',
  stripeChargeApplicationFeeAmount: 'stripeChargeApplicationFeeAmount',
  stripeChargeBalanceTransaction: 'stripeChargeBalanceTransaction',
  stripeChargeCalculatedStatementDescriptor: 'stripeChargeCalculatedStatementDescriptor',
  stripeChargeCaptured: 'stripeChargeCaptured',
  stripeChargeCreated: 'stripeChargeCreated',
  stripeChargeCurrency: 'stripeChargeCurrency',
  stripeChargeCustomer: 'stripeChargeCustomer',
  stripeChargeDescription: 'stripeChargeDescription',
  stripeChargeDisputed: 'stripeChargeDisputed',
  stripeChargeFailureBalanceTransaction: 'stripeChargeFailureBalanceTransaction',
  stripeChargeFailureCode: 'stripeChargeFailureCode',
  stripeChargeFailureMessage: 'stripeChargeFailureMessage',
  stripeChargeBillingDetails: 'stripeChargeBillingDetails',
  stripeChargeFraudDetails: 'stripeChargeFraudDetails',
  stripeChargeMetadata: 'stripeChargeMetadata',
  stripeChargeOutcome: 'stripeChargeOutcome',
  stripeChargePaymentMethodDetails: 'stripeChargePaymentMethodDetails',
  stripeChargeInvoice: 'stripeChargeInvoice',
  stripeChargeLivemode: 'stripeChargeLivemode',
  stripeChargeOnBehalfOf: 'stripeChargeOnBehalfOf',
  stripeChargePaid: 'stripeChargePaid',
  stripeChargePaymentIntent: 'stripeChargePaymentIntent',
  stripeChargePaymentMethod: 'stripeChargePaymentMethod',
  stripeChargeReceiptEmail: 'stripeChargeReceiptEmail',
  stripeChargeReceiptNumber: 'stripeChargeReceiptNumber',
  stripeChargeReceiptUrl: 'stripeChargeReceiptUrl',
  stripeChargeRefunded: 'stripeChargeRefunded',
  stripeChargeReview: 'stripeChargeReview',
  stripeChargeSourceTransfer: 'stripeChargeSourceTransfer',
  stripeChargeStatementDescriptor: 'stripeChargeStatementDescriptor',
  stripeChargeStatementDescriptorSuffix: 'stripeChargeStatementDescriptorSuffix',
  stripeChargeStatus: 'stripeChargeStatus',
  stripeChargeTransferData: 'stripeChargeTransferData',
  stripeChargeTransferGroup: 'stripeChargeTransferGroup',
  stripePaymentIntentId: 'stripePaymentIntentId',
  stripePaymentIntentObject: 'stripePaymentIntentObject',
  stripePaymentIntentAmount: 'stripePaymentIntentAmount',
  stripePaymentIntentAmountCapturable: 'stripePaymentIntentAmountCapturable',
  stripePaymentIntentAmountReceived: 'stripePaymentIntentAmountReceived',
  stripePaymentIntentApplication: 'stripePaymentIntentApplication',
  stripePaymentIntentApplicationFeeAmount: 'stripePaymentIntentApplicationFeeAmount',
  stripePaymentIntentCanceledAt: 'stripePaymentIntentCanceledAt',
  stripePaymentIntentCancellationReason: 'stripePaymentIntentCancellationReason',
  stripePaymentIntentCaptureMethod: 'stripePaymentIntentCaptureMethod',
  stripePaymentIntentClientSecret: 'stripePaymentIntentClientSecret',
  stripePaymentIntentConfirmationMethod: 'stripePaymentIntentConfirmationMethod',
  stripePaymentIntentCreated: 'stripePaymentIntentCreated',
  stripePaymentIntentCurrency: 'stripePaymentIntentCurrency',
  stripePaymentIntentCustomer: 'stripePaymentIntentCustomer',
  stripePaymentIntentDescription: 'stripePaymentIntentDescription',
  stripePaymentIntentLatestCharge: 'stripePaymentIntentLatestCharge',
  stripePaymentIntentLivemode: 'stripePaymentIntentLivemode',
  stripePaymentIntentOnBehalfOf: 'stripePaymentIntentOnBehalfOf',
  stripePaymentIntentPaymentMethod: 'stripePaymentIntentPaymentMethod',
  stripePaymentIntentPaymentMethodTypes: 'stripePaymentIntentPaymentMethodTypes',
  stripePaymentIntentReceiptEmail: 'stripePaymentIntentReceiptEmail',
  stripePaymentIntentReview: 'stripePaymentIntentReview',
  stripePaymentIntentSetupFutureUsage: 'stripePaymentIntentSetupFutureUsage',
  stripePaymentIntentSource: 'stripePaymentIntentSource',
  stripePaymentIntentStatementDescriptor: 'stripePaymentIntentStatementDescriptor',
  stripePaymentIntentStatementDescriptorSuffix: 'stripePaymentIntentStatementDescriptorSuffix',
  stripePaymentIntentStatus: 'stripePaymentIntentStatus',
  stripePaymentIntentTransferGroup: 'stripePaymentIntentTransferGroup',
  stripePaymentIntentAmountDetails: 'stripePaymentIntentAmountDetails',
  stripePaymentIntentAutomaticPaymentMethods: 'stripePaymentIntentAutomaticPaymentMethods',
  stripePaymentIntentMetadata: 'stripePaymentIntentMetadata',
  stripePaymentIntentPaymentMethodOptions: 'stripePaymentIntentPaymentMethodOptions',
  stripePaymentIntentInvoice: 'stripePaymentIntentInvoice',
  stripePaymentIntentShipping: 'stripePaymentIntentShipping',
  stripePaymentIntentInvoiceId: 'stripePaymentIntentInvoiceId',
  stripePaymentIntentLastPaymentError: 'stripePaymentIntentLastPaymentError',
  stripePaymentIntentNextAction: 'stripePaymentIntentNextAction',
  stripePaymentIntentProcessing: 'stripePaymentIntentProcessing',
  stripePaymentIntentTransferData: 'stripePaymentIntentTransferData',
  paymentMethodCardBrand: 'paymentMethodCardBrand',
  paymentMethodCardLast4: 'paymentMethodCardLast4',
  paymentMethodPaymentType: 'paymentMethodPaymentType',
  paymentMethodNetwork: 'paymentMethodNetwork'
};

exports.Prisma.VProjectContractorScalarFieldEnum = {
  contractorId: 'contractorId',
  userId: 'userId',
  email: 'email',
  businessName: 'businessName',
  currentBuildRegionId: 'currentBuildRegionId',
  attributes: 'attributes',
  aboutSummary: 'aboutSummary',
  whyYardzenLovesSummary: 'whyYardzenLovesSummary',
  yearsInBusiness: 'yearsInBusiness',
  licenseNumber: 'licenseNumber',
  active: 'active',
  paused: 'paused',
  approved: 'approved',
  isTest: 'isTest',
  minSuccessBudget: 'minSuccessBudget',
  maxSuccessBudget: 'maxSuccessBudget',
  stripeConnectedAccountId: 'stripeConnectedAccountId',
  rating: 'rating',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs',
  buildProjectId: 'buildProjectId',
  pipefyDtbCardId: 'pipefyDtbCardId',
  totalContractValue: 'totalContractValue',
  contractorProjectLinkCreatedTs: 'contractorProjectLinkCreatedTs',
  contractorProjectLinkUpdatedTs: 'contractorProjectLinkUpdatedTs',
  rank: 'rank',
  matchService: 'matchService',
  matchedTs: 'matchedTs',
  metadata: 'metadata',
  isMatched: 'isMatched'
};

exports.Prisma.VBuildProjectScalarFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  accountManagerId: 'accountManagerId',
  internalNotes: 'internalNotes',
  proFacingNotes: 'proFacingNotes',
  createdTs: 'createdTs',
  updatedTs: 'updatedTs',
  addressId: 'addressId',
  addressLine1: 'addressLine1',
  addressLine2: 'addressLine2',
  city: 'city',
  state: 'state',
  zipcode: 'zipcode',
  latitude: 'latitude',
  longitude: 'longitude',
  phone: 'phone',
  vProjectContractorContractorId: 'vProjectContractorContractorId',
  vProjectContractorBuildProjectId: 'vProjectContractorBuildProjectId'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.UserOrderByRelevanceFieldEnum = {
  id: 'id',
  pipefyClientCardId: 'pipefyClientCardId',
  accountId: 'accountId'
};

exports.Prisma.RenderFeedbackOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  yzAnonymousId: 'yzAnonymousId',
  style: 'style',
  comments: 'comments',
  likedFrom: 'likedFrom',
  imageUrl: 'imageUrl'
};

exports.Prisma.AccountOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.ApiKeyOrderByRelevanceFieldEnum = {
  digest: 'digest',
  id: 'id',
  roles: 'roles',
  userId: 'userId'
};

exports.Prisma.BuildRegionOrderByRelevanceFieldEnum = {
  id: 'id',
  internalName: 'internalName',
  displayName: 'displayName',
  lastUpdatedBy: 'lastUpdatedBy',
  contractorId: 'contractorId',
  accountManagerId: 'accountManagerId'
};

exports.Prisma.AccountManagerOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  projectManagerId: 'projectManagerId',
  email: 'email',
  name: 'name',
  bio: 'bio',
  thumbnailMediaId: 'thumbnailMediaId',
  consultCallUrl: 'consultCallUrl',
  kickOffCallUrl: 'kickOffCallUrl',
  slackChannelId: 'slackChannelId',
  zendeskEmail: 'zendeskEmail'
};

exports.Prisma.AccountManagerGroupOrderByRelevanceFieldEnum = {
  id: 'id',
  key: 'key',
  name: 'name',
  description: 'description'
};

exports.Prisma.AccountManagerGroupMemberOrderByRelevanceFieldEnum = {
  accountManagerId: 'accountManagerId',
  groupId: 'groupId'
};

exports.Prisma.spatial_ref_sysOrderByRelevanceFieldEnum = {
  auth_name: 'auth_name',
  srtext: 'srtext',
  proj4text: 'proj4text'
};

exports.Prisma.GalleryImageOrderByRelevanceFieldEnum = {
  id: 'id',
  city: 'city',
  state: 'state',
  region: 'region',
  styles: 'styles',
  designPackage: 'designPackage',
  amenities: 'amenities',
  fingerprint: 'fingerprint',
  yardAttributes: 'yardAttributes'
};

exports.Prisma.ConversationOrderByRelevanceFieldEnum = {
  id: 'id',
  sid: 'sid'
};

exports.Prisma.ConversationParticipantOrderByRelevanceFieldEnum = {
  id: 'id',
  twilioId: 'twilioId',
  conversationId: 'conversationId',
  twilioSid: 'twilioSid',
  contractorId: 'contractorId',
  userProfileId: 'userProfileId'
};

exports.Prisma.MessageOrderByRelevanceFieldEnum = {
  id: 'id',
  sid: 'sid',
  conversationId: 'conversationId',
  body: 'body',
  author: 'author',
  fromAccountManager: 'fromAccountManager'
};

exports.Prisma.ConversationParticipantCursorOrderByRelevanceFieldEnum = {
  id: 'id',
  conversationParticipantId: 'conversationParticipantId',
  messageId: 'messageId'
};

exports.Prisma.ScheduledSmsNotificationsOrderByRelevanceFieldEnum = {
  id: 'id',
  status: 'status',
  sid: 'sid',
  phone: 'phone',
  participantId: 'participantId'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};

exports.Prisma.ScheduledNotificationOrderByRelevanceFieldEnum = {
  id: 'id',
  errors: 'errors',
  address: 'address',
  template: 'template'
};

exports.Prisma.BuildProjectMemberOrderByRelevanceFieldEnum = {
  userId: 'userId',
  buildProjectId: 'buildProjectId'
};

exports.Prisma.BuildProjectOrderByRelevanceFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  accountManagerId: 'accountManagerId',
  internalNotes: 'internalNotes',
  proFacingNotes: 'proFacingNotes',
  firebaseProjectId: 'firebaseProjectId',
  pipefyClientCardId: 'pipefyClientCardId'
};

exports.Prisma.EstimateOrderByRelevanceFieldEnum = {
  id: 'id',
  contractorId: 'contractorId',
  buildProjectId: 'buildProjectId',
  description: 'description',
  sentToClientBy: 'sentToClientBy',
  evaluationNotes: 'evaluationNotes',
  clonedFromEstimateId: 'clonedFromEstimateId',
  proEstimateNumber: 'proEstimateNumber',
  proTermDetails: 'proTermDetails'
};

exports.Prisma.EstimateWorkLineItemOrderByRelevanceFieldEnum = {
  id: 'id',
  estimateId: 'estimateId',
  name: 'name',
  description: 'description',
  clientFeedbackNotes: 'clientFeedbackNotes',
  clonedFromEstimateWorkLineItemId: 'clonedFromEstimateWorkLineItemId'
};

exports.Prisma.EstimatePaymentLineItemOrderByRelevanceFieldEnum = {
  id: 'id',
  estimateId: 'estimateId',
  name: 'name',
  paymentDue: 'paymentDue'
};

exports.Prisma.EstimateBidFileOrderByRelevanceFieldEnum = {
  estimateId: 'estimateId',
  mediaId: 'mediaId'
};

exports.Prisma.EvaluationTagOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name'
};

exports.Prisma.ItemTagOrderByRelevanceFieldEnum = {
  estimateLineItemId: 'estimateLineItemId',
  tagName: 'tagName'
};

exports.Prisma.EstimateEvaluationTagOrderByRelevanceFieldEnum = {
  estimateId: 'estimateId',
  evaluationTagId: 'evaluationTagId'
};

exports.Prisma.EstimateWorkItemTagDefOrderByRelevanceFieldEnum = {
  name: 'name'
};

exports.Prisma.AddressOrderByRelevanceFieldEnum = {
  id: 'id',
  businessName: 'businessName',
  addressLine1: 'addressLine1',
  addressLine2: 'addressLine2',
  city: 'city',
  state: 'state',
  zipcode: 'zipcode',
  phone: 'phone'
};

exports.Prisma.UserProfileOrderByRelevanceFieldEnum = {
  userId: 'userId',
  email: 'email',
  firstName: 'firstName',
  lastName: 'lastName',
  mailingAddressId: 'mailingAddressId',
  phone: 'phone',
  leadZipcode: 'leadZipcode',
  yzAnonymousId: 'yzAnonymousId'
};

exports.Prisma.DesignAgentProfileOrderByRelevanceFieldEnum = {
  userId: 'userId',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  headshotId: 'headshotId'
};

exports.Prisma.DesignAgentPermissionsOrderByRelevanceFieldEnum = {
  id: 'id',
  designAgentProfileId: 'designAgentProfileId'
};

exports.Prisma.CustomerLeadsOrderByRelevanceFieldEnum = {
  yzAnonymousId: 'yzAnonymousId',
  userId: 'userId',
  email: 'email',
  firstName: 'firstName',
  lastName: 'lastName',
  leadSource: 'leadSource',
  zipcode: 'zipcode',
  addressLine1: 'addressLine1',
  addressLine2: 'addressLine2',
  city: 'city',
  state: 'state',
  phone: 'phone',
  leadRankScoreId: 'leadRankScoreId'
};

exports.Prisma.CartOrderByRelevanceFieldEnum = {
  id: 'id',
  packageName: 'packageName',
  lotSize: 'lotSize',
  sku: 'sku',
  customerLeadId: 'customerLeadId',
  paymentIntentId: 'paymentIntentId'
};

exports.Prisma.CartPromotionalCodeOrderByRelevanceFieldEnum = {
  id: 'id',
  code: 'code',
  discountType: 'discountType',
  discount: 'discount',
  cartId: 'cartId'
};

exports.Prisma.CartAddOnOrderByRelevanceFieldEnum = {
  id: 'id',
  sku: 'sku',
  name: 'name',
  cartId: 'cartId'
};

exports.Prisma.UserTermsOfServiceOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  typeOfTos: 'typeOfTos'
};

exports.Prisma.ContractorAbilityOrderByRelevanceFieldEnum = {
  name: 'name'
};

exports.Prisma.ContractorAbilityLinkOrderByRelevanceFieldEnum = {
  name: 'name',
  contractorProfileId: 'contractorProfileId'
};

exports.Prisma.ProjectElementRequiredAbilityOrderByRelevanceFieldEnum = {
  name: 'name',
  projectElementId: 'projectElementId',
  contractorAbilityName: 'contractorAbilityName'
};

exports.Prisma.ProjectElementOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  notes: 'notes'
};

exports.Prisma.DesignProjectElementOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  hasuraBaseId: 'hasuraBaseId',
  hasuraBaseType: 'hasuraBaseType',
  hasuraBaseName: 'hasuraBaseName',
  unitName: 'unitName',
  projectElementId: 'projectElementId'
};

exports.Prisma.BuildRegionsChangeLogOrderByRelevanceFieldEnum = {
  id: 'id',
  buildRegionId: 'buildRegionId',
  lastUpdatedBy: 'lastUpdatedBy'
};

exports.Prisma.MediaOrderByRelevanceFieldEnum = {
  id: 'id',
  bucketName: 'bucketName',
  objectName: 'objectName',
  mimeType: 'mimeType',
  uri: 'uri',
  uploaderId: 'uploaderId',
  contractorId: 'contractorId',
  buildProjectId: 'buildProjectId',
  estimateId: 'estimateId',
  designProjectId: 'designProjectId',
  messageId: 'messageId',
  revisionId: 'revisionId',
  designProjectDeliverableId: 'designProjectDeliverableId',
  notes: 'notes',
  designAgentProfileId: 'designAgentProfileId',
  feedbackMediaId: 'feedbackMediaId'
};

exports.Prisma.RevisionOrderByRelevanceFieldEnum = {
  id: 'id',
  contractorId: 'contractorId',
  shareMediaLink: 'shareMediaLink',
  clientFirstName: 'clientFirstName',
  clientLastName: 'clientLastName',
  projectCity: 'projectCity',
  projectState: 'projectState',
  projectPackage: 'projectPackage'
};

exports.Prisma.ContractorProfileOrderByRelevanceFieldEnum = {
  contractorId: 'contractorId',
  userId: 'userId',
  email: 'email',
  businessName: 'businessName',
  currentBuildRegionId: 'currentBuildRegionId',
  aboutSummary: 'aboutSummary',
  whyYardzenLovesSummary: 'whyYardzenLovesSummary',
  promotionalMessage: 'promotionalMessage',
  licenseNumber: 'licenseNumber',
  stripeConnectedAccountId: 'stripeConnectedAccountId',
  phoneNumber: 'phoneNumber',
  yelpUrl: 'yelpUrl',
  googleUrl: 'googleUrl',
  calendlyEmail: 'calendlyEmail',
  addressId: 'addressId',
  website: 'website',
  notes: 'notes',
  initialBuildRegionId: 'initialBuildRegionId',
  createdBy: 'createdBy',
  updatedBy: 'updatedBy'
};

exports.Prisma.ContractorInsuranceOrderByRelevanceFieldEnum = {
  id: 'id',
  contractorId: 'contractorId',
  mediaId: 'mediaId',
  policyNumber: 'policyNumber'
};

exports.Prisma.ContractorLicenseOrderByRelevanceFieldEnum = {
  id: 'id',
  contractorId: 'contractorId',
  mediaId: 'mediaId',
  licenseNumber: 'licenseNumber',
  confirmationLink: 'confirmationLink'
};

exports.Prisma.ContractorContactOrderByRelevanceFieldEnum = {
  id: 'id',
  contractorId: 'contractorId',
  firstName: 'firstName',
  lastName: 'lastName',
  phone: 'phone',
  email: 'email'
};

exports.Prisma.LoginHistoryOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  contractorId: 'contractorId',
  userAgent: 'userAgent',
  ipAddress: 'ipAddress',
  location: 'location'
};

exports.Prisma.ContractorReviewOrderByRelevanceFieldEnum = {
  id: 'id',
  contractorId: 'contractorId',
  author: 'author',
  summary: 'summary'
};

exports.Prisma.BuildProjectElementOrderByRelevanceFieldEnum = {
  buildProjectId: 'buildProjectId',
  projectElementId: 'projectElementId'
};

exports.Prisma.StyleProfileOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  timeline: 'timeline'
};

exports.Prisma.SiteWalkOrderByRelevanceFieldEnum = {
  id: 'id',
  gcalEventId: 'gcalEventId',
  groupKey: 'groupKey',
  createdBy: 'createdBy',
  updatedBy: 'updatedBy',
  contractorId: 'contractorId',
  buildProjectId: 'buildProjectId'
};

exports.Prisma.ContractorProjectLinkOrderByRelevanceFieldEnum = {
  contractorId: 'contractorId',
  buildProjectId: 'buildProjectId',
  pipefyDtbCardId: 'pipefyDtbCardId',
  pipefyCardPhaseId: 'pipefyCardPhaseId',
  matchSource: 'matchSource'
};

exports.Prisma.ProjectContractorMatchOrderByRelevanceFieldEnum = {
  contractorId: 'contractorId',
  buildProjectId: 'buildProjectId',
  matchService: 'matchService'
};

exports.Prisma.ProjectEligibleContractorGraveyardOrderByRelevanceFieldEnum = {
  contractorId: 'contractorId',
  buildProjectId: 'buildProjectId'
};

exports.Prisma.MatchingRunLogOrderByRelevanceFieldEnum = {
  id: 'id',
  buildProjectId: 'buildProjectId'
};

exports.Prisma.CityProjectElementOrderByRelevanceFieldEnum = {
  id: 'id',
  city: 'city',
  fingerprint: 'fingerprint',
  projectElementId: 'projectElementId'
};

exports.Prisma.StyleProfileLikeGalleryImageOrderByRelevanceFieldEnum = {
  styleProfileId: 'styleProfileId',
  galleryImageId: 'galleryImageId'
};

exports.Prisma.ContractorMetricOrderByRelevanceFieldEnum = {
  marketId: 'marketId',
  contractorId: 'contractorId',
  contractorBusinessName: 'contractorBusinessName'
};

exports.Prisma.ContractorMetricAggregateOrderByRelevanceFieldEnum = {
  contractorId: 'contractorId'
};

exports.Prisma.MarketMetricOrderByRelevanceFieldEnum = {
  marketId: 'marketId',
  marketInternalName: 'marketInternalName',
  marketDisplayName: 'marketDisplayName',
  marketTier: 'marketTier',
  marketZipCodeArray: 'marketZipCodeArray'
};

exports.Prisma.StripePaymentIntentOrderByRelevanceFieldEnum = {
  id: 'id',
  object: 'object',
  application: 'application',
  cancellationReason: 'cancellationReason',
  captureMethod: 'captureMethod',
  clientSecret: 'clientSecret',
  confirmationMethod: 'confirmationMethod',
  currency: 'currency',
  customer: 'customer',
  description: 'description',
  latestCharge: 'latestCharge',
  onBehalfOf: 'onBehalfOf',
  paymentMethodId: 'paymentMethodId',
  paymentMethodTypes: 'paymentMethodTypes',
  receiptEmail: 'receiptEmail',
  review: 'review',
  setupFutureUsage: 'setupFutureUsage',
  source: 'source',
  statementDescriptor: 'statementDescriptor',
  statementDescriptorSuffix: 'statementDescriptorSuffix',
  status: 'status',
  transferGroup: 'transferGroup',
  invoiceId: 'invoiceId',
  paymentOrderId: 'paymentOrderId'
};

exports.Prisma.StripePaymentMethodOrderByRelevanceFieldEnum = {
  id: 'id',
  object: 'object',
  billingDetailsEmail: 'billingDetailsEmail',
  billingDetailsName: 'billingDetailsName',
  billingDetailsPhone: 'billingDetailsPhone',
  billingDetailsAddressCity: 'billingDetailsAddressCity',
  billingDetailsAddressCountry: 'billingDetailsAddressCountry',
  billingDetailsAddressLine1: 'billingDetailsAddressLine1',
  billingDetailsAddressLine2: 'billingDetailsAddressLine2',
  billingDetailsAddressPostalCode: 'billingDetailsAddressPostalCode',
  billingDetailsAddressState: 'billingDetailsAddressState',
  cardBrand: 'cardBrand',
  cardChecksAddressLine1Check: 'cardChecksAddressLine1Check',
  cardChecksAddressPostalCodeCheck: 'cardChecksAddressPostalCodeCheck',
  cardCvcCheck: 'cardCvcCheck',
  cardCountry: 'cardCountry',
  cardFingerprint: 'cardFingerprint',
  cardFunding: 'cardFunding',
  cardGeneratedFrom: 'cardGeneratedFrom',
  cardLast4: 'cardLast4',
  cardNetworksAvailable: 'cardNetworksAvailable',
  cardNetworksPreferred: 'cardNetworksPreferred',
  cardWallet: 'cardWallet',
  customer: 'customer',
  type: 'type'
};

exports.Prisma.StripeChargeOrderByRelevanceFieldEnum = {
  id: 'id',
  object: 'object',
  application: 'application',
  applicationFee: 'applicationFee',
  balanceTransaction: 'balanceTransaction',
  calculatedStatementDescriptor: 'calculatedStatementDescriptor',
  currency: 'currency',
  customer: 'customer',
  description: 'description',
  failureBalanceTransaction: 'failureBalanceTransaction',
  failureCode: 'failureCode',
  failureMessage: 'failureMessage',
  invoice: 'invoice',
  onBehalfOf: 'onBehalfOf',
  paymentIntent: 'paymentIntent',
  paymentMethod: 'paymentMethod',
  receiptEmail: 'receiptEmail',
  receiptNumber: 'receiptNumber',
  receiptUrl: 'receiptUrl',
  review: 'review',
  sourceTransfer: 'sourceTransfer',
  statementDescriptor: 'statementDescriptor',
  statementDescriptorSuffix: 'statementDescriptorSuffix',
  status: 'status',
  transferData: 'transferData',
  transferGroup: 'transferGroup'
};

exports.Prisma.StripeRefundOrderByRelevanceFieldEnum = {
  id: 'id',
  object: 'object',
  balanceTransaction: 'balanceTransaction',
  charge: 'charge',
  currency: 'currency',
  paymentIntent: 'paymentIntent',
  reason: 'reason',
  receiptNumber: 'receiptNumber',
  sourceTransferReversal: 'sourceTransferReversal',
  status: 'status',
  transferReversal: 'transferReversal'
};

exports.Prisma.StripeBalanceTransactionOrderByRelevanceFieldEnum = {
  id: 'id',
  currency: 'currency',
  description: 'description',
  status: 'status',
  source: 'source',
  type: 'type',
  reportingCategory: 'reportingCategory'
};

exports.Prisma.StripeTaxTransactionOrderByRelevanceFieldEnum = {
  id: 'id',
  taxCalculationId: 'taxCalculationId',
  paymentIntentId: 'paymentIntentId'
};

exports.Prisma.ElementContractorAbilityLinkOrderByRelevanceFieldEnum = {
  elementId: 'elementId',
  name: 'name',
  contractorAbilityName: 'contractorAbilityName'
};

exports.Prisma.InvoiceOrderByRelevanceFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  connectedAccountId: 'connectedAccountId',
  receiptEmail: 'receiptEmail',
  name: 'name',
  description: 'description',
  clientNotes: 'clientNotes',
  confirmationMessage: 'confirmationMessage',
  internalNotes: 'internalNotes',
  createdBy: 'createdBy',
  updatedBy: 'updatedBy',
  voidedBy: 'voidedBy',
  contractorId: 'contractorId',
  estimateId: 'estimateId',
  yzFeeRate: 'yzFeeRate',
  proInvoiceReference: 'proInvoiceReference'
};

exports.Prisma.InvoiceLineItemOrderByRelevanceFieldEnum = {
  id: 'id',
  invoiceId: 'invoiceId',
  name: 'name',
  description: 'description'
};

exports.Prisma.InvoicePaybackTransferOrderByRelevanceFieldEnum = {
  invoiceId: 'invoiceId',
  stripeChargeId: 'stripeChargeId',
  stripeTransferId: 'stripeTransferId',
  stripePaymentId: 'stripePaymentId'
};

exports.Prisma.UrlOrderByRelevanceFieldEnum = {
  shortUrl: 'shortUrl',
  longUrl: 'longUrl'
};

exports.Prisma.MutexOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.ActionAcknoledgmenetOrderByRelevanceFieldEnum = {
  key: 'key'
};

exports.Prisma.PipefyCardOrderByRelevanceFieldEnum = {
  pipe_id: 'pipe_id'
};

exports.Prisma.PipefyActionOrderByRelevanceFieldEnum = {
  id: 'id',
  actiontype: 'actiontype',
  moveToStageName: 'moveToStageName',
  fieldUpdateId: 'fieldUpdateId',
  fieldUpdateName: 'fieldUpdateName',
  moveFromStageName: 'moveFromStageName',
  onPhaseName: 'onPhaseName',
  pipe_id: 'pipe_id'
};

exports.Prisma.SurveyOrderByRelevanceFieldEnum = {
  id: 'id',
  surveyKey: 'surveyKey',
  surveyDesc: 'surveyDesc'
};

exports.Prisma.SurveyQuestionOrderByRelevanceFieldEnum = {
  id: 'id',
  text: 'text',
  description: 'description',
  questionKey: 'questionKey',
  surveyId: 'surveyId'
};

exports.Prisma.SurveyResponseOrderByRelevanceFieldEnum = {
  id: 'id',
  surveyId: 'surveyId',
  buildProjectId: 'buildProjectId',
  userId: 'userId',
  nextQuestionId: 'nextQuestionId',
  yzAnonymousId: 'yzAnonymousId',
  outcome: 'outcome'
};

exports.Prisma.SurveyQuestionResponseOrderByRelevanceFieldEnum = {
  surveyResponseId: 'surveyResponseId',
  surveyQuestionId: 'surveyQuestionId',
  nextQuestionAskedId: 'nextQuestionAskedId'
};

exports.Prisma.SurveyQuestionBranchOrderByRelevanceFieldEnum = {
  id: 'id',
  condition: 'condition',
  fromQuestionId: 'fromQuestionId',
  toQuestionId: 'toQuestionId',
  responseFromQuestionId: 'responseFromQuestionId'
};

exports.Prisma.InProgressPaymentOrderByRelevanceFieldEnum = {
  id: 'id',
  paymentIntentId: 'paymentIntentId',
  clientSecret: 'clientSecret',
  status: 'status',
  invoiceId: 'invoiceId',
  connectedAccountId: 'connectedAccountId'
};

exports.Prisma.DesignInspirationLinkOrderByRelevanceFieldEnum = {
  id: 'id',
  buildProjectId: 'buildProjectId',
  link: 'link'
};

exports.Prisma.DeprecatedProMatchOrderByRelevanceFieldEnum = {
  id: 'id',
  contractorId: 'contractorId',
  pipefyCardId: 'pipefyCardId',
  matchService: 'matchService',
  buildProjectId: 'buildProjectId'
};

exports.Prisma.IdempotencyKeyOrderByRelevanceFieldEnum = {
  key: 'key'
};

exports.Prisma.ContractorShareLinkOrderByRelevanceFieldEnum = {
  id: 'id',
  revisionId: 'revisionId',
  userId: 'userId',
  contractorId: 'contractorId',
  createdForContractorId: 'createdForContractorId'
};

exports.Prisma.EmailReplyStatusOrderByRelevanceFieldEnum = {
  id: 'id',
  sengridEmailId: 'sengridEmailId',
  from: 'from',
  conversationId: 'conversationId',
  status: 'status',
  error: 'error'
};

exports.Prisma.ConfigOrderByRelevanceFieldEnum = {
  id: 'id',
  key: 'key',
  value: 'value'
};

exports.Prisma.PipefyPhaseMetadataOrderByRelevanceFieldEnum = {
  pipeId: 'pipeId',
  phaseId: 'phaseId',
  pipeName: 'pipeName',
  phaseName: 'phaseName'
};

exports.Prisma.PipefyFormSubmissionHistoryOrderByRelevanceFieldEnum = {
  id: 'id',
  pipefyCardId: 'pipefyCardId',
  contractorId: 'contractorId',
  phaseName: 'phaseName',
  phaseId: 'phaseId'
};

exports.Prisma.ZipCodeAnalysisOrderByRelevanceFieldEnum = {
  zipcode: 'zipcode',
  state: 'state',
  city: 'city'
};

exports.Prisma.DesignProjectOrderByRelevanceFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  accountManagerId: 'accountManagerId',
  designerProfileId: 'designerProfileId',
  houseModelerProfileId: 'houseModelerProfileId'
};

exports.Prisma.DesignProjectDeliverableOrderByRelevanceFieldEnum = {
  id: 'id',
  designProjectId: 'designProjectId',
  createdBy: 'createdBy'
};

exports.Prisma.DesignProjectDeliverableFeedbackOrderByRelevanceFieldEnum = {
  id: 'id',
  designProjectDeliverableId: 'designProjectDeliverableId',
  notes: 'notes',
  authorId: 'authorId',
  imageCoordinates: 'imageCoordinates',
  annotatedImageId: 'annotatedImageId'
};

exports.Prisma.DesignProjectDeliverableAssetOrderByRelevanceFieldEnum = {
  id: 'id',
  assetId: 'assetId',
  designProjectDeliverableId: 'designProjectDeliverableId',
  createdBy: 'createdBy'
};

exports.Prisma.DesignProjectOnboardingStepOrderByRelevanceFieldEnum = {
  id: 'id',
  designProjectId: 'designProjectId'
};

exports.Prisma.DesignProjectOnboardingBudgetOrderByRelevanceFieldEnum = {
  id: 'id',
  designProjectId: 'designProjectId'
};

exports.Prisma.DesignProjectOnboardingStepProjectElementOrderByRelevanceFieldEnum = {
  designProjectOnboardingStepId: 'designProjectOnboardingStepId',
  projectElementId: 'projectElementId',
  notes: 'notes'
};

exports.Prisma.BudgetDetailOrderByRelevanceFieldEnum = {
  id: 'id',
  designProjectOnboardingStepId: 'designProjectOnboardingStepId'
};

exports.Prisma.PaymentOrderOrderByRelevanceFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  promoCode: 'promoCode',
  currency: 'currency',
  stripeChargeId: 'stripeChargeId'
};

exports.Prisma.PaymentOrderItemOrderByRelevanceFieldEnum = {
  paymentOrderId: 'paymentOrderId',
  productSku: 'productSku',
  designProjectId: 'designProjectId'
};

exports.Prisma.ProductOrderByRelevanceFieldEnum = {
  sku: 'sku',
  name: 'name'
};

exports.Prisma.LeadRankConfigOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.LeadRankScoreOrderByRelevanceFieldEnum = {
  id: 'id',
  leadRankConfigId: 'leadRankConfigId'
};

exports.Prisma.VLatestConversationMessageOrderByRelevanceFieldEnum = {
  conversationId: 'conversationId'
};

exports.Prisma.VInvoiceOrderByRelevanceFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  connectedAccountId: 'connectedAccountId',
  receiptEmail: 'receiptEmail',
  name: 'name',
  description: 'description',
  clientNotes: 'clientNotes',
  confirmationMessage: 'confirmationMessage',
  internalNotes: 'internalNotes',
  createdBy: 'createdBy',
  updatedBy: 'updatedBy',
  voidedBy: 'voidedBy',
  invoiceType: 'invoiceType',
  contractorId: 'contractorId',
  estimateId: 'estimateId',
  yzFeeRate: 'yzFeeRate',
  proInvoiceReference: 'proInvoiceReference',
  stripeChargeId: 'stripeChargeId',
  stripeChargeObject: 'stripeChargeObject',
  stripeChargeApplication: 'stripeChargeApplication',
  stripeChargeApplicationFee: 'stripeChargeApplicationFee',
  stripeChargeBalanceTransaction: 'stripeChargeBalanceTransaction',
  stripeChargeCalculatedStatementDescriptor: 'stripeChargeCalculatedStatementDescriptor',
  stripeChargeCurrency: 'stripeChargeCurrency',
  stripeChargeCustomer: 'stripeChargeCustomer',
  stripeChargeDescription: 'stripeChargeDescription',
  stripeChargeFailureBalanceTransaction: 'stripeChargeFailureBalanceTransaction',
  stripeChargeFailureCode: 'stripeChargeFailureCode',
  stripeChargeFailureMessage: 'stripeChargeFailureMessage',
  stripeChargeInvoice: 'stripeChargeInvoice',
  stripeChargeOnBehalfOf: 'stripeChargeOnBehalfOf',
  stripeChargePaymentIntent: 'stripeChargePaymentIntent',
  stripeChargePaymentMethod: 'stripeChargePaymentMethod',
  stripeChargeReceiptEmail: 'stripeChargeReceiptEmail',
  stripeChargeReceiptNumber: 'stripeChargeReceiptNumber',
  stripeChargeReceiptUrl: 'stripeChargeReceiptUrl',
  stripeChargeReview: 'stripeChargeReview',
  stripeChargeSourceTransfer: 'stripeChargeSourceTransfer',
  stripeChargeStatementDescriptor: 'stripeChargeStatementDescriptor',
  stripeChargeStatementDescriptorSuffix: 'stripeChargeStatementDescriptorSuffix',
  stripeChargeStatus: 'stripeChargeStatus',
  stripeChargeTransferGroup: 'stripeChargeTransferGroup',
  stripePaymentIntentId: 'stripePaymentIntentId',
  stripePaymentIntentObject: 'stripePaymentIntentObject',
  stripePaymentIntentApplication: 'stripePaymentIntentApplication',
  stripePaymentIntentCancellationReason: 'stripePaymentIntentCancellationReason',
  stripePaymentIntentCaptureMethod: 'stripePaymentIntentCaptureMethod',
  stripePaymentIntentClientSecret: 'stripePaymentIntentClientSecret',
  stripePaymentIntentConfirmationMethod: 'stripePaymentIntentConfirmationMethod',
  stripePaymentIntentCurrency: 'stripePaymentIntentCurrency',
  stripePaymentIntentCustomer: 'stripePaymentIntentCustomer',
  stripePaymentIntentDescription: 'stripePaymentIntentDescription',
  stripePaymentIntentLatestCharge: 'stripePaymentIntentLatestCharge',
  stripePaymentIntentOnBehalfOf: 'stripePaymentIntentOnBehalfOf',
  stripePaymentIntentPaymentMethod: 'stripePaymentIntentPaymentMethod',
  stripePaymentIntentPaymentMethodTypes: 'stripePaymentIntentPaymentMethodTypes',
  stripePaymentIntentReceiptEmail: 'stripePaymentIntentReceiptEmail',
  stripePaymentIntentReview: 'stripePaymentIntentReview',
  stripePaymentIntentSetupFutureUsage: 'stripePaymentIntentSetupFutureUsage',
  stripePaymentIntentSource: 'stripePaymentIntentSource',
  stripePaymentIntentStatementDescriptor: 'stripePaymentIntentStatementDescriptor',
  stripePaymentIntentStatementDescriptorSuffix: 'stripePaymentIntentStatementDescriptorSuffix',
  stripePaymentIntentStatus: 'stripePaymentIntentStatus',
  stripePaymentIntentTransferGroup: 'stripePaymentIntentTransferGroup',
  stripePaymentIntentInvoice: 'stripePaymentIntentInvoice',
  stripePaymentIntentInvoiceId: 'stripePaymentIntentInvoiceId',
  paymentMethodCardBrand: 'paymentMethodCardBrand',
  paymentMethodCardLast4: 'paymentMethodCardLast4',
  paymentMethodPaymentType: 'paymentMethodPaymentType',
  paymentMethodNetwork: 'paymentMethodNetwork'
};

exports.Prisma.VProjectContractorOrderByRelevanceFieldEnum = {
  contractorId: 'contractorId',
  userId: 'userId',
  email: 'email',
  businessName: 'businessName',
  currentBuildRegionId: 'currentBuildRegionId',
  aboutSummary: 'aboutSummary',
  whyYardzenLovesSummary: 'whyYardzenLovesSummary',
  licenseNumber: 'licenseNumber',
  stripeConnectedAccountId: 'stripeConnectedAccountId',
  buildProjectId: 'buildProjectId',
  pipefyDtbCardId: 'pipefyDtbCardId',
  matchService: 'matchService'
};

exports.Prisma.VBuildProjectOrderByRelevanceFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  accountManagerId: 'accountManagerId',
  internalNotes: 'internalNotes',
  proFacingNotes: 'proFacingNotes',
  addressId: 'addressId',
  addressLine1: 'addressLine1',
  addressLine2: 'addressLine2',
  city: 'city',
  state: 'state',
  zipcode: 'zipcode',
  phone: 'phone',
  vProjectContractorContractorId: 'vProjectContractorContractorId',
  vProjectContractorBuildProjectId: 'vProjectContractorBuildProjectId'
};
exports.ConversationRole = exports.$Enums.ConversationRole = {
  CUSTOMER: 'CUSTOMER',
  CONTRACTOR: 'CONTRACTOR',
  ADMIN: 'ADMIN'
};

exports.ScheduledNotificationStatus = exports.$Enums.ScheduledNotificationStatus = {
  SENT: 'SENT',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
  PENDING: 'PENDING',
  NON_RECOVERABLE: 'NON_RECOVERABLE'
};

exports.ScheduledNotificationChannel = exports.$Enums.ScheduledNotificationChannel = {
  SMS: 'SMS',
  EMAIL: 'EMAIL',
  CHAT: 'CHAT'
};

exports.TransactionalMessagingPlatform = exports.$Enums.TransactionalMessagingPlatform = {
  CORDIAL: 'CORDIAL',
  TWILIO: 'TWILIO'
};

exports.DesignAgentType = exports.$Enums.DesignAgentType = {
  DESIGNER: 'DESIGNER',
  HOUSE_MODELER: 'HOUSE_MODELER'
};

exports.DesignAgentTier = exports.$Enums.DesignAgentTier = {
  NEW_AGENT: 'NEW_AGENT',
  TIER_1: 'TIER_1',
  TIER_2: 'TIER_2',
  TIER_3: 'TIER_3',
  VIP: 'VIP',
  INFLUENCER: 'INFLUENCER'
};

exports.DesignAgentPermissionType = exports.$Enums.DesignAgentPermissionType = {
  SEND_PROJECT_TO_CLIENT: 'SEND_PROJECT_TO_CLIENT',
  SEND_FEEDBACK_TO_CLIENT: 'SEND_FEEDBACK_TO_CLIENT'
};

exports.ProjectElementCategory = exports.$Enums.ProjectElementCategory = {
  PLANTS: 'PLANTS',
  WATER_FEATURE: 'WATER_FEATURE',
  LAWN: 'LAWN',
  ENTERTAINING: 'ENTERTAINING',
  STRUCTURE: 'STRUCTURE',
  LIGHTING: 'LIGHTING',
  FENCING: 'FENCING',
  PATHED: 'PATHED',
  EXTERIOR: 'EXTERIOR',
  WATER: 'WATER'
};

exports.ActionType = exports.$Enums.ActionType = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE'
};

exports.MediaSource = exports.$Enums.MediaSource = {
  YZ: 'YZ',
  NON_YZ: 'NON_YZ',
  UNKNOWN: 'UNKNOWN',
  MESSAGES: 'MESSAGES',
  ONBOARDING: 'ONBOARDING',
  DESIGN_DELIVERY: 'DESIGN_DELIVERY'
};

exports.MediaTag = exports.$Enums.MediaTag = {
  HEADSHOT: 'HEADSHOT',
  THUMBNAIL: 'THUMBNAIL',
  FRONT_YARD_HORIZONTAL: 'FRONT_YARD_HORIZONTAL',
  FRONT_YARD_KEEP: 'FRONT_YARD_KEEP',
  FRONT_YARD_REMOVE: 'FRONT_YARD_REMOVE',
  FRONT_YARD_SLOPE: 'FRONT_YARD_SLOPE',
  FRONT_YARD_CHATTY_VIDEO: 'FRONT_YARD_CHATTY_VIDEO',
  FRONT_YARD_SLOW_PAN_VIDEO: 'FRONT_YARD_SLOW_PAN_VIDEO',
  BACK_YARD_HORIZONTAL: 'BACK_YARD_HORIZONTAL',
  BACK_YARD_KEEP: 'BACK_YARD_KEEP',
  BACK_YARD_REMOVE: 'BACK_YARD_REMOVE',
  BACK_YARD_SLOPE: 'BACK_YARD_SLOPE',
  BACK_YARD_CHATTY_VIDEO: 'BACK_YARD_CHATTY_VIDEO',
  BACK_YARD_SLOW_PAN_VIDEO: 'BACK_YARD_SLOW_PAN_VIDEO',
  LEFT_SIDE_YARD_HORIZONTAL: 'LEFT_SIDE_YARD_HORIZONTAL',
  LEFT_SIDE_YARD_KEEP: 'LEFT_SIDE_YARD_KEEP',
  LEFT_SIDE_YARD_REMOVE: 'LEFT_SIDE_YARD_REMOVE',
  LEFT_SIDE_YARD_SLOPE: 'LEFT_SIDE_YARD_SLOPE',
  LEFT_SIDE_YARD_CHATTY_VIDEO: 'LEFT_SIDE_YARD_CHATTY_VIDEO',
  LEFT_SIDE_YARD_SLOW_PAN_VIDEO: 'LEFT_SIDE_YARD_SLOW_PAN_VIDEO',
  RIGHT_SIDE_YARD_HORIZONTAL: 'RIGHT_SIDE_YARD_HORIZONTAL',
  RIGHT_SIDE_YARD_KEEP: 'RIGHT_SIDE_YARD_KEEP',
  RIGHT_SIDE_YARD_REMOVE: 'RIGHT_SIDE_YARD_REMOVE',
  RIGHT_SIDE_YARD_SLOPE: 'RIGHT_SIDE_YARD_SLOPE',
  RIGHT_SIDE_YARD_CHATTY_VIDEO: 'RIGHT_SIDE_YARD_CHATTY_VIDEO',
  RIGHT_SIDE_YARD_SLOW_PAN_VIDEO: 'RIGHT_SIDE_YARD_SLOW_PAN_VIDEO',
  DESIGN_INSPIRATION: 'DESIGN_INSPIRATION',
  EXTERIOR_INSPIRATION: 'EXTERIOR_INSPIRATION',
  PLANS_AND_DRAWINGS: 'PLANS_AND_DRAWINGS',
  DESIGN_PROJECT_RENDER: 'DESIGN_PROJECT_RENDER',
  DESIGN_PROJECT_RENDER_FEEDBACK: 'DESIGN_PROJECT_RENDER_FEEDBACK',
  DESIGN_PROJECT_HOUSE_MODEL: 'DESIGN_PROJECT_HOUSE_MODEL'
};

exports.ProjectDigestFrequency = exports.$Enums.ProjectDigestFrequency = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  NONE: 'NONE'
};

exports.ContractorPausedStatusReason = exports.$Enums.ContractorPausedStatusReason = {
  NONE: 'NONE',
  AR_VIOLATION: 'AR_VIOLATION',
  CONTRACTOR_REQUESTED: 'CONTRACTOR_REQUESTED',
  MISSING_LICENSE: 'MISSING_LICENSE',
  NEGATIVE_REVIEWS: 'NEGATIVE_REVIEWS',
  NO_ONLINE_PRESENCE: 'NO_ONLINE_PRESENCE',
  PERFORMANCE_QUALITY_ISSUES: 'PERFORMANCE_QUALITY_ISSUES',
  PRO_DESIGN_ONLY: 'PRO_DESIGN_ONLY',
  REQUESTED: 'REQUESTED',
  UNRESPONSIVE_NO_UPDATES: 'UNRESPONSIVE_NO_UPDATES',
  UNRESPONSIVE_YARDZEN: 'UNRESPONSIVE_YARDZEN',
  VETTING_ISSUE: 'VETTING_ISSUE'
};

exports.ContractorNotApprovedStatusReason = exports.$Enums.ContractorNotApprovedStatusReason = {
  NONE: 'NONE',
  REQUESTED: 'REQUESTED',
  AR_VIOLATION: 'AR_VIOLATION',
  UNENGAGED: 'UNENGAGED',
  BLACKLISTED: 'BLACKLISTED'
};

exports.ContractorAttribute = exports.$Enums.ContractorAttribute = {
  SUPER_PRO: 'SUPER_PRO',
  LICENSED: 'LICENSED',
  BONDED: 'BONDED',
  INSURED: 'INSURED',
  BOOKING_FAST: 'BOOKING_FAST',
  RESPONSIVE_COMMUNICATION: 'RESPONSIVE_COMMUNICATION',
  PREMIUM_EXPERIENCE: 'PREMIUM_EXPERIENCE',
  VALUE_PRO: 'VALUE_PRO',
  YARDZEN_APPROVED: 'YARDZEN_APPROVED',
  YEARS_IN_BUSINESS: 'YEARS_IN_BUSINESS',
  FREE_ESTIMATES: 'FREE_ESTIMATES',
  ECO_FRIENDLY: 'ECO_FRIENDLY',
  FEMALE_FOUNDED: 'FEMALE_FOUNDED',
  BIPOC_OWNED: 'BIPOC_OWNED',
  VETERAN_OWNED: 'VETERAN_OWNED',
  OWNER_OPERATED: 'OWNER_OPERATED',
  FAMILY_OWNED: 'FAMILY_OWNED',
  PTI_ELITE_BUILDER: 'PTI_ELITE_BUILDER',
  PTI_CERTIFIED_BUILDER: 'PTI_CERTIFIED_BUILDER'
};

exports.ContractorReviewSource = exports.$Enums.ContractorReviewSource = {
  YARDZEN: 'YARDZEN',
  GOOGLE: 'GOOGLE',
  YELP: 'YELP',
  HOUZZ: 'HOUZZ',
  HOMEADVISOR: 'HOMEADVISOR'
};

exports.YardLocation = exports.$Enums.YardLocation = {
  FRONT_YARD: 'FRONT_YARD',
  BACK_YARD: 'BACK_YARD',
  FULL_YARD: 'FULL_YARD',
  NOT_SURE: 'NOT_SURE'
};

exports.SiteWalkStatus = exports.$Enums.SiteWalkStatus = {
  SCHEDULED: 'SCHEDULED',
  RESCHEDULED: 'RESCHEDULED',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED'
};

exports.SiteWalkSource = exports.$Enums.SiteWalkSource = {
  CALENDAR: 'CALENDAR',
  PLATFORM_MESSAGE: 'PLATFORM_MESSAGE'
};

exports.ElementType = exports.$Enums.ElementType = {
  PRODUCT: 'PRODUCT',
  MATERIAL: 'MATERIAL'
};

exports.InvoicePaymentMilestone = exports.$Enums.InvoicePaymentMilestone = {
  DEPOSIT: 'DEPOSIT',
  FIRST_PROGRESS_PAYMENT: 'FIRST_PROGRESS_PAYMENT',
  FINAL_PAYMENT: 'FINAL_PAYMENT',
  PROJECT_DEPOSIT: 'PROJECT_DEPOSIT',
  ADDITIONAL_PROGRESS_PAYMENT: 'ADDITIONAL_PROGRESS_PAYMENT',
  CHANGE_ORDER: 'CHANGE_ORDER'
};

exports.InvoiceType = exports.$Enums.InvoiceType = {
  PROJECT_PAYMENT: 'PROJECT_PAYMENT'
};

exports.DesignProjectStage = exports.$Enums.DesignProjectStage = {
  NEW_ORDER: 'NEW_ORDER',
  ONBOARDING_IN_PROGRESS: 'ONBOARDING_IN_PROGRESS',
  WAITING_ON_MODELER_ASSIGNMENT: 'WAITING_ON_MODELER_ASSIGNMENT',
  MODEL_IN_PROGRESS: 'MODEL_IN_PROGRESS',
  WAITING_ON_DESIGNER_ASSIGNMENT: 'WAITING_ON_DESIGNER_ASSIGNMENT',
  DESIGN_REVISION_IN_PROGRESS: 'DESIGN_REVISION_IN_PROGRESS',
  QA: 'QA',
  SUBMITTED_TO_CLIENT: 'SUBMITTED_TO_CLIENT',
  FEEDBACK_IN_PROGRESS: 'FEEDBACK_IN_PROGRESS',
  ON_HOLD: 'ON_HOLD',
  READY_FOR_BUILD: 'READY_FOR_BUILD',
  ARCHIVED: 'ARCHIVED'
};

exports.PackageType = exports.$Enums.PackageType = {
  FRONT_YARD: 'FRONT_YARD',
  BACK_YARD: 'BACK_YARD',
  FULL_YARD: 'FULL_YARD',
  UBER_PREMIUM: 'UBER_PREMIUM',
  BOTANICAL: 'BOTANICAL',
  CURB_APPEAL: 'CURB_APPEAL',
  WHOLE_HOME: 'WHOLE_HOME'
};

exports.DesignProjectDeliverableType = exports.$Enums.DesignProjectDeliverableType = {
  HOUSE_MODEL: 'HOUSE_MODEL',
  DESIGN_REVISION: 'DESIGN_REVISION',
  YARD_STUDY: 'YARD_STUDY'
};

exports.DesignProjectRevisionFeedbackType = exports.$Enums.DesignProjectRevisionFeedbackType = {
  LIKE: 'LIKE',
  CHANGE: 'CHANGE',
  QUESTION: 'QUESTION',
  COMMENT: 'COMMENT'
};

exports.DesignProjectOnboardingStepType = exports.$Enums.DesignProjectOnboardingStepType = {
  goals: 'goals',
  inspiration: 'inspiration',
  plants: 'plants',
  wishlist: 'wishlist',
  photos: 'photos',
  review: 'review',
  exterior: 'exterior'
};

exports.BudgetPreference = exports.$Enums.BudgetPreference = {
  PRIORITIZE_BUDGET: 'PRIORITIZE_BUDGET',
  BALANCE_BUDGET: 'BALANCE_BUDGET',
  PRIORITIZE_VISION: 'PRIORITIZE_VISION'
};

exports.InstallLocation = exports.$Enums.InstallLocation = {
  BACKYARD: 'BACKYARD',
  FRONTYARD: 'FRONTYARD',
  LEFTYARD: 'LEFTYARD',
  RIGHTYARD: 'RIGHTYARD'
};

exports.PaymentOrderStatus = exports.$Enums.PaymentOrderStatus = {
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  REFUNDED: 'REFUNDED',
  PARTIAL_REFUND: 'PARTIAL_REFUND'
};

exports.ProductType = exports.$Enums.ProductType = {
  PACKAGE: 'PACKAGE',
  ADD_ON: 'ADD_ON',
  UPGRADE: 'UPGRADE',
  ADDITIONAL_REVISION: 'ADDITIONAL_REVISION'
};

exports.AddOnType = exports.$Enums.AddOnType = {
  EXTERIOR: 'EXTERIOR',
  EXPEDITED: 'EXPEDITED',
  HOA: 'HOA'
};

exports.LotSize = exports.$Enums.LotSize = {
  STANDARD: 'STANDARD',
  LARGE: 'LARGE'
};

exports.HomeValueSource = exports.$Enums.HomeValueSource = {
  ZIP_CODE_AVERAGE: 'ZIP_CODE_AVERAGE',
  ZILLOW_HOME_VALUE: 'ZILLOW_HOME_VALUE'
};

exports.Prisma.ModelName = {
  User: 'User',
  RenderFeedback: 'RenderFeedback',
  Account: 'Account',
  ApiKey: 'ApiKey',
  BuildRegion: 'BuildRegion',
  AccountManager: 'AccountManager',
  AccountManagerGroup: 'AccountManagerGroup',
  AccountManagerGroupMember: 'AccountManagerGroupMember',
  spatial_ref_sys: 'spatial_ref_sys',
  GalleryImage: 'GalleryImage',
  Conversation: 'Conversation',
  ConversationParticipant: 'ConversationParticipant',
  Message: 'Message',
  ConversationParticipantCursor: 'ConversationParticipantCursor',
  ScheduledSmsNotifications: 'ScheduledSmsNotifications',
  ScheduledNotification: 'ScheduledNotification',
  BuildProjectMember: 'BuildProjectMember',
  BuildProject: 'BuildProject',
  Estimate: 'Estimate',
  EstimateWorkLineItem: 'EstimateWorkLineItem',
  EstimatePaymentLineItem: 'EstimatePaymentLineItem',
  EstimateBidFile: 'EstimateBidFile',
  EvaluationTag: 'EvaluationTag',
  ItemTag: 'ItemTag',
  EstimateEvaluationTag: 'EstimateEvaluationTag',
  EstimateWorkItemTagDef: 'EstimateWorkItemTagDef',
  Address: 'Address',
  UserProfile: 'UserProfile',
  DesignAgentProfile: 'DesignAgentProfile',
  DesignAgentPermissions: 'DesignAgentPermissions',
  CustomerLeads: 'CustomerLeads',
  Cart: 'Cart',
  CartPromotionalCode: 'CartPromotionalCode',
  CartAddOn: 'CartAddOn',
  UserTermsOfService: 'UserTermsOfService',
  ContractorAbility: 'ContractorAbility',
  ContractorAbilityLink: 'ContractorAbilityLink',
  ProjectElementRequiredAbility: 'ProjectElementRequiredAbility',
  ProjectElement: 'ProjectElement',
  DesignProjectElement: 'DesignProjectElement',
  BuildRegionsChangeLog: 'BuildRegionsChangeLog',
  Media: 'Media',
  Revision: 'Revision',
  ContractorProfile: 'ContractorProfile',
  ContractorInsurance: 'ContractorInsurance',
  ContractorLicense: 'ContractorLicense',
  ContractorContact: 'ContractorContact',
  LoginHistory: 'LoginHistory',
  ContractorReview: 'ContractorReview',
  BuildProjectElement: 'BuildProjectElement',
  StyleProfile: 'StyleProfile',
  SiteWalk: 'SiteWalk',
  ContractorProjectLink: 'ContractorProjectLink',
  ProjectContractorMatch: 'ProjectContractorMatch',
  ProjectEligibleContractorGraveyard: 'ProjectEligibleContractorGraveyard',
  MatchingRunLog: 'MatchingRunLog',
  CityProjectElement: 'CityProjectElement',
  StyleProfileLikeGalleryImage: 'StyleProfileLikeGalleryImage',
  ContractorMetric: 'ContractorMetric',
  ContractorMetricAggregate: 'ContractorMetricAggregate',
  MarketMetric: 'MarketMetric',
  StripePaymentIntent: 'StripePaymentIntent',
  StripePaymentMethod: 'StripePaymentMethod',
  StripeCharge: 'StripeCharge',
  StripeRefund: 'StripeRefund',
  StripeBalanceTransaction: 'StripeBalanceTransaction',
  StripeTaxTransaction: 'StripeTaxTransaction',
  ElementContractorAbilityLink: 'ElementContractorAbilityLink',
  Invoice: 'Invoice',
  InvoiceLineItem: 'InvoiceLineItem',
  InvoicePaybackTransfer: 'InvoicePaybackTransfer',
  Url: 'Url',
  Mutex: 'Mutex',
  ActionAcknoledgmenet: 'ActionAcknoledgmenet',
  PipefyCard: 'PipefyCard',
  PipefyAction: 'PipefyAction',
  Survey: 'Survey',
  SurveyQuestion: 'SurveyQuestion',
  SurveyResponse: 'SurveyResponse',
  SurveyQuestionResponse: 'SurveyQuestionResponse',
  SurveyQuestionBranch: 'SurveyQuestionBranch',
  InProgressPayment: 'InProgressPayment',
  DesignInspirationLink: 'DesignInspirationLink',
  DeprecatedProMatch: 'DeprecatedProMatch',
  IdempotencyKey: 'IdempotencyKey',
  ContractorShareLink: 'ContractorShareLink',
  EmailReplyStatus: 'EmailReplyStatus',
  Config: 'Config',
  PipefyPhaseMetadata: 'PipefyPhaseMetadata',
  PipefyFormSubmissionHistory: 'PipefyFormSubmissionHistory',
  ZipCodeAnalysis: 'ZipCodeAnalysis',
  DesignProject: 'DesignProject',
  DesignProjectDeliverable: 'DesignProjectDeliverable',
  DesignProjectDeliverableFeedback: 'DesignProjectDeliverableFeedback',
  DesignProjectDeliverableAsset: 'DesignProjectDeliverableAsset',
  DesignProjectOnboardingStep: 'DesignProjectOnboardingStep',
  DesignProjectOnboardingBudget: 'DesignProjectOnboardingBudget',
  DesignProjectOnboardingStepProjectElement: 'DesignProjectOnboardingStepProjectElement',
  BudgetDetail: 'BudgetDetail',
  PaymentOrder: 'PaymentOrder',
  PaymentOrderItem: 'PaymentOrderItem',
  Product: 'Product',
  LeadRankConfig: 'LeadRankConfig',
  LeadRankScore: 'LeadRankScore',
  VLatestConversationMessage: 'VLatestConversationMessage',
  VInvoice: 'VInvoice',
  VProjectContractor: 'VProjectContractor',
  VBuildProject: 'VBuildProject'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
